/*
  Populates the currency/country localization dropdowns on first interaction.

  The country data is rendered once per page as a compact JSON array by
  snippets/header.localization-selector.liquid:

    [["AF","Afghanistan","AFN","؋"], ...]
     iso   name           currency symbol

  Previously this logic was inlined twice per page (once for the desktop
  header, once for the mobile menu drawer). It is now a single cacheable
  external asset that serves every .localization-selector on the page.
*/
(function () {
  'use strict';

  /*
    Keyed per form ELEMENT, not per data-country-form value: the snippet is
    rendered twice (desktop header + mobile menu drawer), so the values
    'desktop'/'mobile' each occur more than once in the document.
  */
  var populated = typeof WeakSet === 'function' ? new WeakSet() : null;

  function populateCountryForm(form) {
    if (populated) {
      if (populated.has(form)) return;
      populated.add(form);
    } else {
      if (form.hasAttribute('data-country-populated')) return;
      form.setAttribute('data-country-populated', '');
    }

    var dataEl = document.querySelector('[data-country-list]');
    if (!dataEl) return;

    var countries;
    try {
      countries = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!countries || !countries.length) return;

    var frag = document.createDocumentFragment();

    countries.forEach(function (c) {
      var iso = c[0];
      var name = c[1];
      var currency = c[2];
      var symbol = c[3];

      var btn = document.createElement('button');
      btn.type = 'submit';
      btn.name = 'country_code';
      btn.value = iso;
      btn.className = 'w-full flex text-left items-center gap-2 group';

      var flag = document.createElement('span');
      flag.className = 'country-flags country-flags--' + iso;

      var label = document.createElement('span');
      label.className = 'opacity-50 group-hover:opacity-100 transition-opacity';
      label.textContent = name + ' (' + currency + ' ' + symbol + ')';

      btn.appendChild(flag);
      btn.appendChild(label);
      frag.appendChild(btn);
    });

    form.appendChild(frag);
  }

  function bind(selector) {
    var trigger = selector.querySelector('button');
    if (!trigger) return;
    trigger.addEventListener(
      'click',
      function () {
        selector.querySelectorAll('[data-country-form]').forEach(populateCountryForm);
      },
      { once: true }
    );
  }

  document.querySelectorAll('.localization-selector').forEach(bind);
})();
